export function sleep(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export function formatDate(): string {
    return new Date().toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric',
    });
}

export const getAssessmentYearOptions = () => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth(); // 0-based
    const currentYear = currentDate.getFullYear();
    // Assuming financial year changes in April (month index 3)
    const currentFYStart = currentMonth < 3 ? currentYear - 1 : currentYear;
    const years = [];
    // Show only current financial year and next financial year.
    for (let i = 0; i <= 1; i++) {
        const start = currentFYStart + i;
        const end = String(start + 1).slice(-2);
        const value = `${start}-${end}`;
        years.push({
            value,
            label: i === 0 ? `${value} (Current A.Y.)` : value
        });
    }
    return years;
};
